export const PERMISSION_ITEMS = [
  'View Dashboard & Reports',
  'View Inventory',
  'Add Products',
  'Edit Products',
  'Delete Products',
  'Add Procurement (IN)',
  'Add Issue (OUT)',
  'Submit Requests',
  'Approve/Reject Requests',
  'Manage Quotations',
  'Manage Users',
];

export function defaultPermissions(role = 'viewer') {
  const isAdmin = role === 'admin';
  const managerLike = isAdmin || role === 'sub_admin' || role === 'store_manager';
  return {
    'View Dashboard & Reports': true,
    'View Inventory': true,
    'Add Products': managerLike,
    'Edit Products': isAdmin,
    'Delete Products': isAdmin,
    'Add Procurement (IN)': managerLike,
    'Add Issue (OUT)': managerLike,
    'Submit Requests': true,
    'Approve/Reject Requests': isAdmin || role === 'sub_admin',
    'Manage Quotations': managerLike,
    'Manage Users': isAdmin,
  };
}

export function normalizePermissions(value) {
  if (!value) return {};
  if (typeof value === 'string') {
    try { return JSON.parse(value) || {}; }
    catch { return {}; }
  }
  return value || {};
}
